import { render } from "./Cubic.vue?vue&type=template&id=5c481d0e&ts=true"
import script from "./Cubic.vue?vue&type=script&lang=ts"
export * from "./Cubic.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__